import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import NoData from '../CustomizedComponents/DisplayData/NoData';
import CustomerDetail from './CustomerDetail';
import styled from 'styled-components';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';

const LoadingWrapper = styled.div`
  height: 2px;
`;

const CustomerWrapper = ({ id, customer, loading, error, handlers }) => {
  const { usersLoading, data } = customer;

  const noData = 'app.dataTable.body.noData';
  const showNothingToDisplay = !data && !loading && !error && id !== 'new';
  const showError = !data && !!error && id !== 'new';
  const showBody = (data && !error && !loading && !usersLoading) || (id === 'new' && !usersLoading);

  return (
    <>
      {showNothingToDisplay && (
        <NoData>
          <FormattedMessage id={noData} />
        </NoData>
      )}
      {showError && (
        <NoData>
          <FormattedMessage id={noData} />
        </NoData>
      )}
      {!showBody && (
        <LoadingWrapper>
          <LoadingIndicator />
        </LoadingWrapper>
      )}
      {showBody && <CustomerDetail customer={customer} handlers={handlers} error={error} loading={loading} />}
    </>
  );
};

CustomerWrapper.propTypes = {
  id: PropTypes.any,
  customer: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.any,
  handlers: PropTypes.object,
};

export default CustomerWrapper;
